import classNames from 'classnames';
import { getShortTextByKey } from '$cms/getDataByKey';
import { LoginButton } from '$components/basic/LoginButton';
import { useAppContext } from '$util/AppContext';
import type { CmsContentDictionary } from '$cms/index';
import { Title } from '@/components/atoms/Title';
import { Styled } from './styled';

export interface HeaderProps {
  readonly isGuestUser: boolean;
  readonly className?: string;
}

const getCmsData = (cmsData: CmsContentDictionary) => {
  const getShortText = getShortTextByKey.bind(cmsData);

  return {
    title: getShortText('checkout.personalDetails.contactForm.title', 'Your contact details'),
    loginQuestion: getShortText(
      'checkout.personalDetails.contactForm.loginQuestion',
      'Already have an account?'
    ),
    login: getShortText('checkout.personalDetails.contactForm.login', 'Login'),
    confirmDetails: getShortText(
      'checkout.personalDetails.contactForm.confirmDetails',
      'Confirm your contact details'
    ),
  };
};

function Header({ isGuestUser, className, ...props }: HeaderProps): JSX.Element {
  const AppContext = useAppContext();
  const {
    cmsContent: { dictionary },
  } = AppContext;

  const { title, loginQuestion, login, confirmDetails } = getCmsData(dictionary);

  return (
    <Styled className={classNames('PersonalDetailsHeader', className)} {...props}>
      <Title h={5} className={className}>
        {isGuestUser ? (
          <>
            {title}
            <p>
              {loginQuestion} <LoginButton label={login} />
            </p>
          </>
        ) : (
          <div> {confirmDetails} </div>
        )}
      </Title>
    </Styled>
  );
}

Header.displayname = 'PersonalDetailsHeader';

export { Header };
